// Suppress ResizeObserver errors that are common with Monaco Editor
// These are benign warnings that don't affect functionality

export function suppressResizeObserverError() {
  // Suppress console errors
  const resizeObserverErr = window.console.error;
  window.console.error = (...args: any[]) => {
    const arg = args[0];
    if (typeof arg === 'string' && 
        (arg.includes('ResizeObserver loop completed with undelivered notifications') ||
         arg.includes('ResizeObserver loop limit exceeded'))) {
      return;
    }
    resizeObserverErr.apply(window.console, args);
  };

  // Also suppress the error at the window level
  window.addEventListener('error', (e) => {
    if (e.message?.includes('ResizeObserver loop completed with undelivered notifications') ||
        e.message?.includes('ResizeObserver loop limit exceeded')) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
      return false;
    }
  }, true);

  // For React development error overlay
  if (process.env.NODE_ENV === 'development') {
    // The React error overlay uses a different mechanism
    const originalError = window.Error;
    window.Error = class extends originalError {
      constructor(message?: string, options?: ErrorOptions) {
        if (message?.includes('ResizeObserver loop completed') || 
            message?.includes('ResizeObserver loop limit exceeded')) {
          // Create a harmless error instead
          super('', options);
          return;
        }
        super(message, options);
      }
    } as any;
  }
}